export default {
  header: {
    title: '💛 Lasă un bacșiș echipei',
    subtitle: '100% merge la echipă',
  },
  buttons: {
    other: 'Altul',
    none: 'Fără',
  },
  summary_label: 'Bacșiș',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} este valoarea maximă a bacșișului',
      },
    },
  },
};
